import React, { useEffect, useRef } from "react";
import { ServiceOptionProps } from "./shared.types";
import styled from "styled-components";

import { v4 as uuidv4 } from "uuid";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import * as symbolUtils from "@arcgis/core/symbols/support/symbolUtils";

const StyledServiceOption = styled.span`
  font-size: var(--lib-text-size-0);
  color: var(--lib-primary-green);

  display: inline-flex;

  > :last-child {
    padding-inline-start: 5px;
  }
`;


const ServiceOption = ({ label, location }: ServiceOptionProps) => {
  const symbolRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (location && symbolRef?.current) {
      const layer = location.layer as any;
      const uniqueValueInfo = layer.renderer.uniqueValueInfos.find(
        (info) => info.label === location.attributes.resource_type
      );
      const symbol = uniqueValueInfo?.symbol || layer.renderer.defaultSymbol;
      symbolUtils.renderPreviewHTML(symbol, {
        node: symbolRef.current
      });
  
    }
  
  }, [location]);
  
  return (
    <StyledServiceOption key={uuidv4()}>
      <FontAwesomeIcon aria-hidden={true} icon={faCheck}></FontAwesomeIcon>
      <span>{label}</span>
      {location && 
        <span ref={symbolRef}></span>
      }
    </StyledServiceOption>
  );
};

export default ServiceOption;
